import React, { useState, useEffect } from "react";
import './RoleServiceMap.css';
import axios from "axios";
const RoleServiceMap = () => {
    const [roleId, setRoleId] = useState('');
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/roles`);  // Adjust URL if necessary
                if (response.data && Array.isArray(response.data)) {
                    setRoles(response.data);  // Store the roles in state
                } else {
                    setMessage("No roles found.");
                }
            } catch (error) {
                setMessage("Error fetching roles.");
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchRoles();
    }, []);

    return (
        <div className="Role-service-master">
            <div className="outside-Role-service-master">
                {/* <h3>Role Service Map</h3> */}
            </div>
            <div className="Role-service-master-table">
                <div className="inside-Role-service-master">
                    <h3>Role Service Map</h3>
                </div>
                <div className="Role-service-master-containerbody">
                    <div className="rrole-Service-form" >
                        <label className="rrole-Service-label">Select Role</label>
                        <select className="rrole-Service-select"
                            id="role"
                            value={roleId}
                            onChange={(e) => setRoleId(e.target.value)}
                            required

                        >
                            <option  hidden className="middle">Select</option>
                            {loading ? (
                                <option value="" disabled>Loading roles...</option>
                            ) : (
                                roles.map((role) => (
                                    <option key={role.roleId} value={role.roleId}>
                                        {role.roleName} {/* Display role name */}
                                    </option>
                                ))
                            )}
                        </select>

                    </div>
                </div>
                <div className='table-div-Role-service'>
                    <table className='fdbk-Role-service'>
                        <thead className="theadtr-Role-service" >

                            <tr  >
                                <th>S.NO</th>
                                <th>Service Name</th>

                                <th> </th>
                            </tr>
                        </thead>
                        <tbody  >
                            <tr>
                                <td>1.</td>
                                <td>Admin</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />
                                </td>
                            </tr>
                            <tr>
                                <td>2.</td>
                                <td>User</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />

                                </td>
                            </tr>
                            {/* <tr>
                                <td>3.</td>
                                <td>Guest</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />

                                </td>
                            </tr>
                            <tr>
                                <td>4.</td>
                                <td>Operator</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />

                                </td>
                            </tr>
                            <tr>
                                <td>5.</td>
                                <td>Tester</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />

                                </td>
                            </tr>
                            <tr>
                                <td>6.</td>
                                <td>Accountant</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />

                                </td>
                            </tr>
                            <tr>
                                <td>7.</td>
                                <td>Manager</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />

                                </td>
                            </tr>
                            <tr>
                                <td>8.</td>
                                <td>Team Lead</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />

                                </td>
                            </tr>
                            <tr>
                                <td>9.</td>
                                <td>CEO</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />

                                </td>
                            </tr>
                            <tr>
                                <td>10.</td>
                                <td>Tiru</td>

                                <td>
                                    <input type="checkbox" className="check-Role-service" />

                                </td>
                            </tr> */}
                        </tbody>
                    </table>

                    
                </div>
                <div className="Role-serviceButtons">
                        <button className="Role-service-btn" style={{ visibility: "hidden" }}>ADD</button>
                        <button className="btn-Role-service" style={{ visibility: "hidden" }}>CANCEL</button>
                    </div>
            </div>
        </div>
    );
}
export default RoleServiceMap;